import { Link } from '@mui/material'
import React from 'react'
import { Link as RouterLink } from 'react-router-dom';

export const AboutUsPage = () => {
  return (
    <div>AboutUsPage<br />
    <Link component={RouterLink} to={`/`} color="primary.main">
        VOLVER
    </Link> 
    </div>
  )
}
